var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogoSymbolH32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7452 5.12974V0.651367L0 6.26969V31.5928L21.99 27.1959V31.5928L40.544 27.8473L45.7838 31.5928V26.7888L49.6493 26.056V0.651367L27.7452 5.12974Z",
    fill: "url(#paint0_linear_1281_514)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44336 19.8677L11.0819 12.458L15.7204 19.8677H6.44336Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7325 20.0305C24.0096 20.0305 25.8556 18.2807 25.8556 16.1221C25.8556 13.9636 24.0096 12.2137 21.7325 12.2137C19.4554 12.2137 17.6094 13.9636 17.6094 16.1221C17.6094 18.2807 19.4554 20.0305 21.7325 20.0305Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2073 12.3766H35.3047V19.8677H43.2073V12.3766Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0746 15.9168L26.8555 18.9683L27.9488 20.0046L31.1679 16.9531L30.0746 15.9168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6254 12.2616L29.4062 15.3131L30.4995 16.3495L33.7187 13.298L32.6254 12.2616Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1281_514",
    x1: 46.2773,
    y1: 37.9279,
    x2: 22.9607,
    y2: 11.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    stopColor: "#F02826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoSymbolH32);
export default __webpack_public_path__ + "static/media/IconLogoSymbolH32.bdcc16177554c2993c61be8a3bb2ebcf.svg";
export { ForwardRef as ReactComponent };